import {
  ADD_ORDER,
  ADD_ORDER_SUCCESS,
  ADD_ORDER_ERROR,
  FETCH_ORDER_DETAIL,
  FETCH_ORDER_DETAIL_SUCCESS,
  FETCH_ORDER_DETAIL_ERROR,
  FETCH_ORDER_DETAIL_RZ,
  FETCH_ORDER_DETAIL_RZ_SUCCESS,
  FETCH_ORDER_DETAIL_RZ_ERROR,
  FETCH_ORDERS,
  FETCH_ORDERS_SUCCESS,
  FETCH_ORDERS_ERROR,
  UPDATE_ORDER_STATUS,
  UPDATE_ORDER_STATUS_SUCCESS,
  UPDATE_ORDER_STATUS_ERROR,
} from '../actionTypes';

export const addOrder = (data) => ({
  type: ADD_ORDER,
  payload: data,
});

export const addOrderSuccess = (user) => ({
  type: ADD_ORDER_SUCCESS,
  payload: user,
});

export const addOrderError = (message) => ({
  type: ADD_ORDER_ERROR,
  payload: message,
});

export const fetchOrderDetail = (data) => ({
  type: FETCH_ORDER_DETAIL,
  payload: data,
});

export const fetchOrderDetailSuccess = (user) => ({
  type: FETCH_ORDER_DETAIL_SUCCESS,
  payload: user,
});

export const fetchOrderDetailError = (message) => ({
  type: FETCH_ORDER_DETAIL_ERROR,
  payload: message,
});

export const fetchOrderDetailByRz = (data) => ({
  type: FETCH_ORDER_DETAIL_RZ,
  payload: data,
});

export const fetchOrderDetailByRzSuccess = (user) => ({
  type: FETCH_ORDER_DETAIL_RZ_SUCCESS,
  payload: user,
});

export const fetchOrderDetailByRzError = (message) => ({
  type: FETCH_ORDER_DETAIL_RZ_ERROR,
  payload: message,
});

export const fetchOrders = (data) => ({
  type: FETCH_ORDERS,
  payload: data,
});

export const fetchOrdersSuccess = (user, pageData) => ({
  type: FETCH_ORDERS_SUCCESS,
  payload: user,
  pageData,
});

export const fetchOrdersError = (message) => ({
  type: FETCH_ORDERS_ERROR,
  payload: message,
});

export const updateOrderStatus = (data) => ({
  type: UPDATE_ORDER_STATUS,
  payload: data,
});

export const updateOrderStatusSuccess = (data) => ({
  type: UPDATE_ORDER_STATUS_SUCCESS,
  payload: data,
});

export const updateOrderStatusError = (error) => ({
  type: UPDATE_ORDER_STATUS_ERROR,
  payload: error,
});
